export const VERSION = '4.2.5-bowl';
export const GIT_HASH = 'ec04c7b35b135736226b6c14a50dfd90d3ab96cb';
export const BUILD_DATE = '';
